import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from '@/Static/IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const DeleteIcon = ({ id, onClick, size = 'small', className, disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Delete}
      alt="img"
      className={cn(styles.icon, className, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
